// ── Auto-add free companion on cart/add (collection + PDP quick-add) ──
// Product-page bundles already add the freebie via product-bundle.liquid.
// This script covers Add to Cart from collection cards / express ATC.
(function () {
  // ═══════════════════════════════════════════════════════════
  //  MASTER SWITCH — set to false to disable companion auto-add
  // ═══════════════════════════════════════════════════════════
  const ENABLED = true;

  if (!ENABLED) {
    console.log("[companion-add] Script is DISABLED. Skipping setup.");
    return;
  }

  // Free Stinger STK8 wiring kit (product 7866505232477)
  const COMPANION_VARIANT_ID = "43173486133341";
  const COMPANION_PRODUCT_ID = "7866505232477";

  // Main products that should receive a free STK8 when added from anywhere
  const QUALIFYING_PRODUCT_IDS = new Set([
    "7835113193565",
    "7833751060573",
    "7835113029725",
  ]);

  let isCompanionRequest = false;
  const productCache = new Map(); // handle -> qualifies boolean

  console.log("[companion-add] Script loaded and running (STK8 freebie)");

  const now = () => performance.now();
  const ms = (start) => `${(performance.now() - start).toFixed(0)}ms`;

  function productIdFromCartItem(item) {
    if (item.product_id != null) return String(item.product_id);
    return null;
  }

  function isQualifyingProductId(productId) {
    return QUALIFYING_PRODUCT_IDS.has(String(productId));
  }

  function isCompanionCartItem(item) {
    return (
      String(item.variant_id) === COMPANION_VARIANT_ID ||
      String(item.product_id) === COMPANION_PRODUCT_ID
    );
  }

  async function fetchProductQualifies(handle) {
    if (productCache.has(handle)) {
      return productCache.get(handle);
    }

    const start = now();
    try {
      const res = await fetch(`/products/${handle}.json`);
      console.log("[companion-add] Fetch", handle, "status:", res.status, "took", ms(start));

      if (!res.ok) {
        productCache.set(handle, false);
        return false;
      }

      const data = await res.json();
      const qualifies = isQualifyingProductId(data.product.id);
      console.log("[companion-add]", handle, "| id:", data.product.id, "| qualifies:", qualifies);
      productCache.set(handle, qualifies);
      return qualifies;
    } catch (e) {
      console.log("[companion-add] Fetch error for", handle, e.message);
      productCache.set(handle, false);
      return false;
    }
  }

  async function isQualifyingCartItem(item) {
    if (isCompanionCartItem(item)) return false;

    const productId = productIdFromCartItem(item);
    if (productId && isQualifyingProductId(productId)) return true;

    const handle = (item.url || "").replace("/products/", "").split("?")[0].split("#")[0];
    if (!handle) return false;
    return await fetchProductQualifies(handle);
  }

  async function checkAndAddCompanion(productUrl, addedVariantId, addedProductId) {
    const totalStart = now();
    console.log(
      "[companion-add] ▶ START checkAndAddCompanion:",
      productUrl,
      "variant:",
      addedVariantId,
      "product:",
      addedProductId
    );

    try {
      // Never treat the freebie itself as a trigger
      if (
        String(addedVariantId) === COMPANION_VARIANT_ID ||
        String(addedProductId) === COMPANION_PRODUCT_ID
      ) {
        console.log("[companion-add] Added item is the companion, skipping.");
        return;
      }

      let qualifies = false;
      if (addedProductId && isQualifyingProductId(addedProductId)) {
        qualifies = true;
      } else {
        const handle = (productUrl || "").replace("/products/", "").split("?")[0].split("#")[0];
        if (!handle) {
          console.log("[companion-add] No handle/product id, skipping.");
          return;
        }
        qualifies = await fetchProductQualifies(handle);
      }

      if (!qualifies) {
        console.log("[companion-add] Not qualifying, skipping. Total:", ms(totalStart));
        return;
      }

      const cartFetchStart = now();
      const cartRes = await fetch("/cart.js");
      const cart = await cartRes.json();
      console.log("[companion-add] ⏱ Cart fetch took", ms(cartFetchStart), "| items:", cart.items.length);

      const countStart = now();
      let qualifyingCount = 0;
      for (const item of cart.items) {
        if (isCompanionCartItem(item)) continue;
        const q = await isQualifyingCartItem(item);
        if (q) qualifyingCount += item.quantity;
      }
      console.log("[companion-add] ⏱ Cart count loop took", ms(countStart), "| qualifying:", qualifyingCount);

      const companionItem = cart.items.find((item) => isCompanionCartItem(item));
      const currentCompanionQty = companionItem ? companionItem.quantity : 0;

      if (currentCompanionQty >= qualifyingCount) {
        console.log("[companion-add] Companion qty matches, skipping. Total:", ms(totalStart));
        return;
      }

      const neededQty = qualifyingCount - currentCompanionQty;
      console.log("[companion-add] Adding", neededQty, "STK8 companion(s)");

      const addStart = now();
      isCompanionRequest = true;
      const addRes = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          id: Number(COMPANION_VARIANT_ID),
          quantity: neededQty,
          properties: {
            _free_gift: "stk8",
            _free_gift_for: "qualifying_amplifier",
          },
        }),
      });
      const addData = await addRes.json();
      isCompanionRequest = false;

      if (!addRes.ok) {
        console.error("[companion-add] Failed to add companion:", addData);
        return;
      }

      console.log("[companion-add] ⏱ Companion add took", ms(addStart));

      document.dispatchEvent(new CustomEvent("cart:refresh"));
      document.dispatchEvent(new CustomEvent("cart:updated"));
      console.log("[companion-add] ✔ DONE. Total time:", ms(totalStart));
    } catch (e) {
      isCompanionRequest = false;
      console.error("[companion-add] Error:", e, "Total:", ms(totalStart));
    }
  }

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "";
    const response = await originalFetch.apply(this, args);

    if (/\/cart\/add/i.test(url) && !isCompanionRequest) {
      const interceptStart = now();
      console.log("[companion-add] ▶ Intercepted /cart/add");
      try {
        const cloned = response.clone();
        const data = await cloned.json();

        const companionPromises = [];

        if (data.url) {
          companionPromises.push(
            checkAndAddCompanion(data.url, data.variant_id || "", data.product_id || "")
          );
        } else if (data.items && Array.isArray(data.items)) {
          data.items.forEach((item) => {
            if (item.url || item.product_id) {
              companionPromises.push(
                checkAndAddCompanion(item.url || "", item.variant_id || "", item.product_id || "")
              );
            }
          });
        }

        if (companionPromises.length > 0) {
          await Promise.all(companionPromises);
          console.log("[companion-add] ⏱ TOTAL intercept-to-release:", ms(interceptStart));
        }
      } catch (e) {
        console.log("[companion-add] Could not parse response:", e.message);
      }
    }

    return response;
  };
})();
